// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'

export interface ChangeAccountNickname {
  accountId: number
  nickname?: string
}

export interface SimpleResponse {
  errorText?: string
  ok: boolean
}

/**
 * Validate ChangeAccountNickname request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateChangeAccountNickname(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateChangeAccountNickname(request: ChangeAccountNickname): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.accountId === undefined || req.accountId === null) {
    errors.push({
      field: 'accountId',
      code: 'required',
      message: 'accountId is required'
    })
  }

  if (typeof req.nickname === 'string' && req.nickname.length > 64) {
    errors.push({
      field: 'nickname',
      code: 'too_long',
      message: 'nickname must not exceed 64 characters',
      argument: '64'
    })
  }

  return errors
}

export const changeAccountNickname = postEndpoint<ChangeAccountNickname, SimpleResponse>('/account/changeAccountNickname')
